var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "保单名称",
      "prop": "ide"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择保单名称",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.ide),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "ide", $$v)
      },
      expression: "ruleForm.ide"
    }
  }, _vm._l((_vm.bdList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.insurance_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "保单号",
      "prop": "policy_no"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入甲方名称"
    },
    model: {
      value: (_vm.ruleForm.policy_no),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "policy_no", $$v)
      },
      expression: "ruleForm.policy_no"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cd246cc","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bxgl/GzxGl/Gzxgl_pipei.vue
// module id = null
// module chunks = 